import React, { useEffect, useState } from 'react';
import { useAdminApi } from './adminApi';
import VendorsLibrary from '../vendors/VendorsLibrary';

function VendorsTab({ condo, notify }) {
  const api = useAdminApi();
  const [people, setPeople] = useState([]);

  useEffect(() => {
    api.get('/api/admin/users', { condo: condo._id })
      .then((r) => setPeople((r.data.users || []).filter((u) => u.isActive).map((u) => ({ _id: u._id, name: u.name }))))
      .catch(() => setPeople([]));
  }, [api, condo._id]);

  return (
    <VendorsLibrary
      api={api}
      base={`/api/admin/condos/${condo._id}/vendors`}
      quotesBase={`/api/admin/condos/${condo._id}/quotes`}
      people={people}
      notify={notify}
    />
  );
}

export default VendorsTab;
